import { useCallback } from "react";
import {
  matchPath,
  useLocation,
  useNavigate as useRouterNavigate,
} from "react-router-dom";
import useAppStore from "../stores/app";

const titles = [
  { path: "/checkout", title: "Checkout" },
  { path: "/orders/:id", title: "Order" },
  { path: "/terms", title: "Terms & Conditions" },
  { path: "/privacy-policy", title: "Privacy Policy" },
  { path: "/refund-policy", title: "Refund Policy" },
  { path: "/orders", title: "Orders" },
  { path: "/profile", title: "Profile" },
  { path: "/favorites", title: "Favorites" },
  { path: "/addresses", title: "Addresses" },
];

const useNavigate = () => {
  const navigate = useRouterNavigate();
  const { pathname } = useLocation();
  const screenOptions = useAppStore((state) => state.navOptions[pathname]);
  const setNavOptions = useAppStore((state) => state.setNavOptions);
  const goBack = () => navigate(-1);
  const setOptions = useCallback(
    (options: { title?: string }) => setNavOptions(pathname, options),
    [pathname, setNavOptions],
  );
  const routeTitle = titles.find((route) =>
    matchPath(route.path, pathname),
  )?.title;

  return {
    navigate,
    goBack,
    setOptions,
    options: {
      ...screenOptions,
      title: screenOptions?.title ?? routeTitle,
    },
  };
};

export default useNavigate;
